import React from "react";
import { SecondaryLabel } from "@bloomberg/media-ui-article";
import { Lock } from "@bloomberg/media-ui-icons";

import { Story } from "~types/types";

import styles from "./styles.module.css";

interface BoxedLabelProps {
    story: Story;
}

export default function SubscriberLabel({
    story,
}: BoxedLabelProps): React.JSX.Element | null {
    const { premium, archived } = story;

    const showSubscriberOnlyLabel = premium || archived;

    if (showSubscriberOnlyLabel) {
        const text = "This article is for <b>subscribers only</b>.";
        return (
            <SecondaryLabel
                text={<div dangerouslySetInnerHTML={{ __html: text }} />}
                icon={<Lock />}
                className={styles.subscriberLabel}
            />
        );
    }

    // add other secondary label states here
    return null;
}
